export default {
  // ログイン情報
  profile: null,
  // firestoreのデータをstoreで扱いたい場合、collection/documentの定義をここに書く
  administrators: [],
  attributeMaster: [],
  attributeUsers: [],
  categoryMaster: [],
  codeMaster: [],
  companyMaster: [],
  externalLinkMaster: [],
  externalLowerLinkMaster: [],
  facilityMaster: [],
  gateMaster: [],
  grantAttributeHistory: [],
  groupMaster: [],
  holidayMaster: [],
  members: [],
  optionMaster: [],
  priceMaster: [],
  routeSearchFilterMaster: [],
  routeSearchKeywordMaster: [],
  sales: [],
  sentMailHistory: [],
  stationListMaster: [],
  customize: null,
  environment: null,
  management: null,
  properties: null,
  routeSearch: null,
  ticketDisplayLimitMaster: [],
  ticketDistribution: [],
  ticketMaster: [],
  ticketMasterAllocationRatios: [],
};
